/**
 * takes in a bid team object an returns a string value built from the
 * bid teams composite key values. This can be used like an id when needed
 * for bid teams.
 */
export function getBidTeamCompositeKeyAsString(bidTeam: any): string {
  const compositeKey = bidTeam?.compositeKey || {};
  return [compositeKey.leadCompanyKey || 0, compositeKey.offeringKey || 0, compositeKey.altBidSeqNo || 0].join('-');
}

export function getPersonKeysFromBidTeams(bidTeams: ReadonlyArray<any>): ReadonlyArray<number> {
  if (!Array.isArray(bidTeams) || !bidTeams.length) {
    return [];
  }

  return bidTeams.reduce<ReadonlyArray<number>>(
    (personKeys, currentBidTeam) =>
      Array.isArray(currentBidTeam.bidTeamPersonKeys)
        ? personKeys.concat(currentBidTeam.bidTeamPersonKeys)
        : personKeys,
    []
  );
}

export function isCompanyKeyInBidTeam(bidTeam: any, companyKey: number): boolean {
  if (!Array.isArray(bidTeam?.bidTeamMemberKeys) || !companyKey) {
    return false;
  }

  return bidTeam.bidTeamMemberKeys.includes(companyKey);
}

/**
 * Checks if a bid teams array has uninvited suppliers
 * @param bidTeams The bidTeams array transformed via `transformToCuratedBidTeams`
 */
export function hasUninvitedSuppliers(bidTeams: ReadonlyArray<any>): boolean {
  if (!Array.isArray(bidTeams) || !bidTeams.length) {
    return false;
  }

  return Object.values(bidTeams.map(bidTeam => bidTeam.suppliers)) // extract the suppliers object from the array
    .map(supplier => Object.values(supplier)) // extract the suppliers into an array of arrays
    .reduce((acum, current) => acum.concat(current), []) // reduce the suppliers array into a one-level array
    .map((supplier: any) => supplier.people) // extract the people of each supplier
    .map(people => Object.entries(people).map(([key, person]) => person)) // Transforms the object of objects into an array
    .flat() // the array is in an array of arrays form, this will flatten the array into a one-level array
    .some((person: any) => typeof person.invitedTime === 'undefined' || person.invitedTime === null); // finally, check if there are entries with uninvited time either undefined or null
}
